import { Grid, GridItem } from '@chakra-ui/react';
import { InputField } from 'app/components/Core';
import { AudioVersionSelection } from '../AudioVersionSelection';
import { useTuneCoreVersionAudio } from './hooks';
import { IsrcField } from '../IsrcField';

export const TuneCoreVersionAudioForm = ({
  form: {
    register,
    formState: { errors },
  },
  onSubmit,
  primaryAudio,
  audioData,
  releaseVersion,
  primaryAudioDisabled,
  replaceAudioVersion,
  primaryAudioFetching,
  isAudioReplacing,
  updateAudioDetails,
  updateAudioValidations,
}: ReturnType<typeof useTuneCoreVersionAudio>) => {
  const isrcDisabled =
    primaryAudioDisabled ||
    Boolean(primaryAudio?.audioData?.isIsrcAllocatedBySession);

  return (
    <form onSubmit={onSubmit}>
      <Grid templateColumns="repeat(4, 1fr)" columnGap={4} maxW="640" m="auto">
        <GridItem colSpan={{ base: 4 }}>
          <InputField
            {...register('versionTitle')}
            label="Sound Recording Title"
            isInvalid={Boolean(errors?.versionTitle)}
            errorMessage={errors?.versionTitle?.message}
            onBlur={onSubmit}
          />
        </GridItem>
        <GridItem colSpan={{ base: 4, md: 2 }}>
          <AudioVersionSelection
            value={primaryAudio}
            audioData={audioData}
            songTitle={releaseVersion.metadata.songTitle}
            disabled={primaryAudioDisabled}
            onSelect={(audioGuid) => {
              if (audioGuid !== primaryAudio?.value) {
                replaceAudioVersion(audioGuid);
              }
            }}
            versionSongGuid={releaseVersion.song.songGuid}
            loading={primaryAudioFetching || isAudioReplacing}
          />
        </GridItem>
        <GridItem colSpan={{ base: 4, md: 2 }}>
          <IsrcField
            isrc={primaryAudio?.audioData.isrc || ''}
            disabled={isrcDisabled}
            validations={updateAudioValidations}
            saveIsrc={updateAudioDetails}
          />
        </GridItem>
      </Grid>
    </form>
  );
};
